import { render, staticRenderFns } from "./SampleStatsPanel.vue?vue&type=template&id=65161952&scoped=true&"
import script from "./SampleStatsPanel.vue?vue&type=script&lang=js&"
export * from "./SampleStatsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65161952",
  null
  
)

export default component.exports